module.exports = __webpack_public_path__ + "img/28a-produtividade-servico-extra.2af088c1.png";